<template>
  <div v-if="myProfile" class="the-navbar__user-meta flex items-center">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ myProfile.name }}</p>
      <small>{{ myProfile.phone }}</small>
    </div>
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          :src="(myProfile.avatar && myProfile.avatar.url) || placeholder"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <div class="user-details text-left leading-tight sm:block mb-4 mx-2">
            <p class="font-semibold">{{ myProfile.name }}</p>
            <small>{{ myProfile.phone }}</small>
          </div>
          <logout />
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import user_placeholder from "../../../assets/images/user-placeholder.png";
  import Logout from "../Logout.vue";

  export default {
    components: {
      Logout,
    },
    data() {
      return {
        placeholder: user_placeholder,
      };
    },
    computed: {
      ...mapState({
        myProfile: (state) => state.profile.myProfile.data,
      }),
    },
  };
</script>

<style lang="scss">
  .li-logout {
    width: auto;
    display: flex;
    padding: 8px 12px;
    cursor: pointer;
    border-radius: 5px;

    &:hover {
      color: #fff;
      background-color: rgba(var(--vs-danger));
    }
  }

  .user-details {
    @media screen and (min-width: 576px) {
      display: none !important;
    }
  }
</style>
